<!--导航栏-->
<template>
  <div class="mainClassDiv">
    <div
      style="position: absolute;z-index: 9;right: 50px;font-size: 13px;top: 5px;font-weight: 700;"
    >
      <div>
        {{ dateStr }}
      </div>
      <div style="margin-top:5px">欢迎{{ uis.userName }}登录...</div>
    </div>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      style="display: "
    >
      <el-menu-item index="0">
        <span>
          &nbsp;&nbsp;&nbsp;优房联卖管理系统
        </span>
      </el-menu-item>
      <!-- 收房成交管理：QXID=0 或 QXID=1 时显示 -->
      <el-menu-item index="3" v-if="QXID === '0' || QXID === '1'"
        >收房成交管理</el-menu-item
      >
      <!-- 售房成交管理：QXID=0 或 QXID=1 时显示 -->
      <el-menu-item index="4" v-if="QXID === '0' || QXID === '1'"
        >售房成交管理</el-menu-item
      >
      <!-- 机构管理：仅 QXID=0 时显示 -->
      <el-menu-item index="0" v-if="QXID === '0'">机构管理</el-menu-item>
      <!-- 人员管理：仅 QXID=0 时显示 -->
      <el-menu-item index="1" v-if="QXID === '0'">人员管理</el-menu-item>
      <!-- 小区管理：仅 QXID=0 时显示 -->
      <el-menu-item index="2" v-if="QXID === '0'">小区管理</el-menu-item>
      <!-- 学校管理：仅 QXID=0 时显示 -->
      <el-menu-item index="9" v-if="QXID === '0'">学校管理</el-menu-item>
      <!-- 装饰管理：QXID=0 或 QXID=2 时显示 -->
      <el-menu-item index="7" v-if="QXID === '0' || QXID === '2'"
        >装饰管理</el-menu-item
      >
      <!-- 美装材料：QXID=0 或 QXID=2 时显示 -->
      <el-menu-item index="8" v-if="QXID === '0' || QXID === '2'"
        >美装材料</el-menu-item
      >
      <!-- 房源管理：仅 QXID=0 时显示 -->
      <el-menu-item index="10" v-if="QXID === '0'">房源管理</el-menu-item>
      <!-- 财务管理：暂时隐藏 -->
      <el-menu-item index="6" v-if="false">财务管理</el-menu-item>
      <!-- 退出系统：所有用户都显示 -->
      <el-menu-item index="5">退出系统</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
var utilPost, op;
export default {
  name: "NavMainCom",
  components: {},
  props: ["activeIndex"],
  data() {
    return {
      uis: {},
      msg: "",
      dateStr: "",
      QXID: "0" // 默认系统管理员
    };
  },
  created() {
    this.utilPost = this.$util.handler;

    // 从 localStorage 获取用户信息
    try {
      const uisStr = window.localStorage.getItem("uis");
      if (uisStr) {
        this.uis = JSON.parse(uisStr);
        this.QXID = this.uis.QXID || "0";
      }
    } catch (e) {
      console.error("获取用户信息失败", e);
      this.QXID = "0";
    }
  },
  mounted() {
    var that = this;
    setInterval(() => {
      this.dateStr = this.getFormattedTime();
    }, 1000);
  },
  methods: {
    getFormattedTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0"); // 月份补零
      const day = now
        .getDate()
        .toString()
        .padStart(2, "0");
      const hours = now
        .getHours()
        .toString()
        .padStart(2, "0");
      const minutes = now
        .getMinutes()
        .toString()
        .padStart(2, "0");
      const seconds = now
        .getSeconds()
        .toString()
        .padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    handleSelect(key, keyPath) {
      switch (key) {
        case "0": {
          // 主页
          this.$router.push({ path: "/jgGlIndex" });
          break;
        }
        case "1": {
          this.$router.push({ path: "/personGlIndex" });
          break;
        }
        case "2": {
          // 账户信息
          this.$router.push({ path: "/communityGlIndex" });
          break;
        }
        case "9": {
          // 学校管理
          this.$router.push({ path: "/schoolGlIndex" });
          break;
        }
        case "3": {
          this.$router.push({ path: "/sfOrderGlIndex" });
          break;
        }
        case "4": {
          this.$router.push({ path: "/saleOrderGlIndex" });
          break;
        }
        case "6": {
          this.$router.push({ path: "/cwGlIndex" });
          break;
        }
        case "7": {
          this.$router.push({ path: "/accessoriesGlIndex" });
          break;
        }
        case "8": {
          // 美装材料
          this.$router.push({ path: "/newsGlIndex" });
          break;
        }
        case "10": {
          // 房源管理
          this.$router.push({ path: "/houseInfoIndex" });
          break;
        }
        case "5": {
          // 退出系统
          if (!confirm("是否退出系统？")) {
            return;
          }
          // 清空用户信息
          window.localStorage.removeItem("uis");
          // 跳转到登录页面
          this.$router.push({ path: "/" });
          break;
        }
        default: {
          alert("暂未开放");
        }
      }
    }
  }
};
</script>
<style scoped>
.mainClassDiv {
  position: relative;
}
.el-menu--horizontal {
  background-image: url("../../assets/topImg.png") !important;
  background-size: 100%;
}
.el-menu-item {
  font-weight: 600 !important;
  font-size: 14px;
}
/deep/ .el-menu--horizontal > .el-menu-item {
  height: 52px;
  line-height: 52px;
}
</style>



// WEBPACK FOOTER //
// src/components/navCom/NavMainCom.vue